import type { NativeRecording } from '@muzly/shared';

/** iOS `AVAudioSessionPortBuiltInSpeaker`의 값. */
const IOS_BUILTIN_SPEAKER = 'Speaker';
/** Android `AudioDeviceInfo.TYPE_BUILTIN_SPEAKER`. */
const ANDROID_BUILTIN_SPEAKER = 2;

/**
 * 테이크가 내장 스피커로 소리를 내는 경로에서 녹음됐나 — 노래 진단 전 이어폰 권장의 근거.
 *
 * 스피커로 반주를 틀면 마이크가 반주를 같이 듣는다. iOS 는 에코 제거(VPIO)로 막지만 그래도
 * 고역이 깎이고 레벨이 흔들린다. Android 는 에코 제거가 없다(`MuzlyCaptureMeta`). 그래서
 * 경로를 아는 기기에서 스피커면 이어폰을 권한다.
 *
 * - iOS: 직전 테이크의 `outputRouteRaw`(세션 시작 때 출력 포트).
 * - Android: `outputRouteRaw`(연결된 이어폰 종류, 없으면 내장 스피커 — `MuzlyCaptureMeta.outputRoute`).
 *   입력 경로로는 못 가른다 — 블루투스 이어폰은 내장 마이크로 녹음한다.
 *
 * 경로를 모르면 false(출력 포트를 안 싣던 Android 빌드 포함) — 권장은 기능 저하를 막는
 * 안내일 뿐이라, 모르는데 이어폰 낀 사람에게 이어폰을 끼라고 하지 않는다.
 */
export const isSpeakerRoute = (recording: NativeRecording | null): boolean => {
  if (recording === null) {
    return false;
  }
  if (recording.platform === 'ios') {
    return recording.outputRouteRaw === IOS_BUILTIN_SPEAKER;
  }
  if (recording.platform === 'android') {
    return Number(recording.outputRouteRaw) === ANDROID_BUILTIN_SPEAKER;
  }
  return false;
};
